'use strict';

var fs = require('fs');
var yaml = require('js-yaml');
var catalogModel = require('@backstage/catalog-model');
var pluginScaffolderCommon = require('@backstage/plugin-scaffolder-common');
var annotations_schema = require('./schemas/annotations.schema.json.cjs.js');
var repository_schema = require('./schemas/repository.schema.json.cjs.js');
var product_schema = require('./schemas/product.schema.json.cjs.js');
var Ajv = require('ajv');
var ajvFormats = require('ajv-formats');
var relativeSpaceValidation = require('./relativeSpaceValidation.cjs.js');

function _interopDefaultCompat (e) { return e && typeof e === 'object' && 'default' in e ? e : { default: e }; }

var fs__default = /*#__PURE__*/_interopDefaultCompat(fs);
var yaml__default = /*#__PURE__*/_interopDefaultCompat(yaml);
var Ajv__default = /*#__PURE__*/_interopDefaultCompat(Ajv);
var ajvFormats__default = /*#__PURE__*/_interopDefaultCompat(ajvFormats);

const ajv = new Ajv__default.default({ verbose: true });
ajvFormats__default.default(ajv);
function ajvCompiledJsonSchemaValidator(schema) {
  return {
    async check(data) {
      return catalogModel.entityKindSchemaValidator(schema)(data) === data;
    }
  };
}
const VALIDATORS = {
  api: catalogModel.apiEntityV1alpha1Validator,
  component: catalogModel.componentEntityV1alpha1Validator,
  group: catalogModel.groupEntityV1alpha1Validator,
  location: catalogModel.locationEntityV1alpha1Validator,
  template: pluginScaffolderCommon.templateEntityV1beta3Validator,
  user: catalogModel.userEntityV1alpha1Validator,
  system: catalogModel.systemEntityV1alpha1Validator,
  domain: catalogModel.domainEntityV1alpha1Validator,
  resource: catalogModel.resourceEntityV1alpha1Validator,
  repository: ajvCompiledJsonSchemaValidator(repository_schema.default),
  product: ajvCompiledJsonSchemaValidator(product_schema.default)
};
function modifyPlaceholders(obj) {
  for (const k in obj) {
    if (typeof obj[k] === "object") {
      try {
        if (obj[k].$text || obj[k].$openapi || obj[k].$asyncapi) {
          obj[k] = "DUMMY TEXT";
          return;
        }
      } catch {
        throw new Error(
          `Placeholder with name '${k}' is empty. Please remove it or populate it.`
        );
      }
      modifyPlaceholders(obj[k]);
    }
  }
}
const validate = async (fileContents, verbose = true, customAnnotationSchemaLocation = "") => {
  let validator;
  const overrides = {
    isValidEntityName(value) {
      return typeof value === "string" && value.length >= 1 && value.length <= 120 && /^([A-Za-z0-9][-A-Za-z0-9_.]*)?[A-Za-z0-9]$/.test(value);
    },
    isValidLabelValue(value) {
      return typeof value === "string";
    },
    isValidTag(value) {
      return typeof value === "string" && value.length >= 1 && value.length <= 63;
    }
  };
  const validateAnnotations = (entity, idx) => {
    if (!validator) {
      if (customAnnotationSchemaLocation) {
        console.log(
          `Using validation schema from ${customAnnotationSchemaLocation}...`
        );
        const customAnnotationSchema = JSON.parse(
          fs__default.default.readFileSync(customAnnotationSchemaLocation, "utf8")
        );
        validator = ajv.getSchema(customAnnotationSchema.$id);
        if (!validator) {
          validator = ajv.compile(customAnnotationSchema);
        }
      } else {
        validator = ajv.compile(annotations_schema.default);
      }
    }
    if (verbose) {
      console.log(`Validating entity annotations for file document ${idx}`);
    }
    const result = validator(entity);
    if (result === true) {
      return true;
    }
    const [error] = validator.errors || [];
    if (!error) {
      throw new Error(`Malformed annotation, Unknown error`);
    }
    throw new Error(
      `Malformed annotation, ${error.instancePath || "<root>"} ${error.message}`
    );
  };
  try {
    const data = yaml__default.default.loadAll(fileContents, null, { schema: yaml__default.default.CORE_SCHEMA });
    data.forEach((it) => {
      modifyPlaceholders(it);
    });
    const entityPolicies = catalogModel.EntityPolicies.allOf([
      new catalogModel.DefaultNamespaceEntityPolicy(),
      new catalogModel.FieldFormatEntityPolicy(catalogModel.makeValidator(overrides)),
      new catalogModel.NoForeignRootFieldsEntityPolicy(),
      new catalogModel.SchemaValidEntityPolicy()
    ]);
    const responses = await Promise.all(
      data.map((it) => {
        return entityPolicies.enforce(it);
      })
    );
    const validateEntityKind = async (entity) => {
      const results = {};
      for (const v of Object.entries(VALIDATORS)) {
        const result = await v[1].check(entity);
        results[v[0]] = result;
        if (result === true && verbose) {
          console.log(`Validated entity kind '${v[0]}' successfully.`);
        }
      }
      return results;
    };
    const validateEntities = async (entities) => {
      const results = await Promise.all(entities.map(validateEntityKind));
      return Object.values(results[0]).filter((r) => r === false).length > 0;
    };
    const validKind = await validateEntities(data);
    const validAnnotations = data.map(
      (it, idx) => validateAnnotations(it, idx)
    );
    if (validKind && validAnnotations && verbose) {
      console.log("Entity Schema policies validated\n");
      responses.forEach((it) => console.log(yaml__default.default.dump(it)));
    }
    return responses.filter((e) => e !== void 0);
  } catch (e) {
    throw new Error(`Error: ${e instanceof Error ? e.message : String(e)}`);
  }
};
const validateFromFile = async (filepath, verbose = true, customAnnotationSchemaLocation = "") => {
  const fileContents = fs__default.default.readFileSync(filepath, "utf8");
  if (verbose) {
    console.log(`Validating Entity Schema policies for file ${filepath}`);
  }
  const entities = await validate(
    fileContents,
    verbose,
    customAnnotationSchemaLocation
  );
  await relativeSpaceValidation.relativeSpaceValidation(fileContents, filepath, verbose);
  return entities;
};

exports.validate = validate;
exports.validateFromFile = validateFromFile;
//# sourceMappingURL=validator.cjs.js.map
